import { Stack, Typography, Box } from '@mui/material';
import { Analytics } from '@watershed/analytics/analyticsUtils';
import ArrowRight from '@watershed/icons/components/ArrowRight';
import { IconElement } from '@watershed/icons/Icon';
import Button from '@watershed/ui-core/components/Button';
import { ReactNode } from 'react';

export default function HomeCardBase({
  title,
  link,
  action,
  accessory,
  children,
}: {
  title: (
    | { label: React.ReactNode; icon: IconElement }
    | { label?: undefined; icon?: undefined }
  ) & { heading?: React.ReactNode; subLabel?: React.ReactNode };
  link?: { label: React.ReactNode; event: string; to: string };
  action?: ReactNode;
  accessory?: ReactNode;
  children: ReactNode;
}) {
  const Icon = title.icon;
  return (
    <Box width="100%">
      <Stack
        borderRadius={2}
        bgcolor={(theme) => theme.palette.white}
        border={(theme) => `1px solid ${theme.palette.grey20}`}
      >
        <Stack
          flexDirection="row"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          px={2}
          py={2}
          borderBottom={(theme) => `1px dashed ${theme.palette.grey20}`}
        >
          {Icon && (
            <Stack flexDirection="row" gap={1} alignItems="center">
              <Stack
                justifyContent="center"
                alignItems="center"
                borderRadius={4}
                direction="row"
                gap={0.75}
                bgcolor={(theme) => theme.palette.white}
                border={(theme) => `1px solid ${theme.palette.grey20}`}
                boxShadow="0px 1px 0.5px 0px rgba(79, 89, 110, 0.08), 0px -1px 4px 0px rgba(0, 0, 0, 0.04) inset"
                px={1.5}
                py={0.5}
                sx={{
                  userSelect: 'none',
                }}
              >
                <Icon color={(theme) => theme.palette.grey50} size={16} />
                <Typography variant="body2" fontWeight={600}>
                  {title.label}
                </Typography>
              </Stack>
            </Stack>
          )}
          {title.heading && (
            <Typography variant="h2">{title.heading}</Typography>
          )}
          {title.subLabel && (
            <Typography variant="body2">{title.subLabel}</Typography>
          )}
          {accessory}
          {link && (
            <Button
              href={link.to}
              endIcon={<ArrowRight />}
              onClick={() => Analytics.action(link.event)}
              children={link.label}
            />
          )}
          {action}
        </Stack>
        {children}
      </Stack>
    </Box>
  );
}
